import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { InputNumberMask } from '../../../../../CommonComponents/OPL/Input/InputNumberMask';
import { StepCard } from '../../StepCard/StepCard';

export const TOTAL_INVESTABLE_ASSETS = 'totalInvestableAssets';

export interface TotalInvestableAssetsFormField {
  [TOTAL_INVESTABLE_ASSETS]?: string;
}

export const TotalValueInvestableAssets = () => {
  const {
    setValue,
    formState: { errors },
    control,
  } = useFormContext<TotalInvestableAssetsFormField>();

  return (
    <StepCard>
      <Text color="neutral.700" fontSize="h3" fontWeight={500}>
        What&apos;s the total value of your investable assets?
      </Text>
      <Text color="neutral.500" mt="8">
        Add up your checking, savings, mutual funds, IRAs, 401(k)s, public stocks
      </Text>

      <Box display="flex" mt="32">
        <Controller
          control={control}
          name={TOTAL_INVESTABLE_ASSETS}
          render={({ field: { value } }) => (
            <InputNumberMask
              label="Total Investable Assets"
              placeholder="Total Investable Assets"
              leftIcon="fa fa-dollar-sign"
              name={TOTAL_INVESTABLE_ASSETS}
              value={value}
              formVariant={errors[TOTAL_INVESTABLE_ASSETS] ? 'error' : undefined}
              helperText={errors[TOTAL_INVESTABLE_ASSETS]?.message}
              onValueChange={({ floatValue }) => {
                setValue(
                  TOTAL_INVESTABLE_ASSETS,
                  floatValue !== undefined ? floatValue.toString() : '',
                );
              }}
            />
          )}
        />
      </Box>
    </StepCard>
  );
};
